module.exports = __webpack_public_path__ + "static/media/justin.aee5739f.jpeg";